import './Listing.scss';
import Component from './Listing.js';
export default Component;
